function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 86,
  height: 129,
  fill: "#00245A",
  rx: 2
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#5B41F0",
  d: "M1.131.15l67.93 9.005a3 3 0 012.606 2.974V116.87a3 3 0 01-2.606 2.974L1.13 128.85a.999.999 0 01-1.131-.991V1.14A1 1 0 011.13.149z"
}), /*#__PURE__*/React.createElement(Rect, {
  width: 5.059,
  height: 10.118,
  x: 59.863,
  y: 62.392,
  fill: "#161E2A",
  rx: 2.529
}), /*#__PURE__*/React.createElement(Rect, {
  width: 9.275,
  height: 1.686,
  x: 53.118,
  y: 66.608,
  fill: "#161E2A",
  rx: 0.843
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#5B41F0",
  fillRule: "nonzero",
  d: "M61.549 66.108h-7.588a1.343 1.343 0 100 2.686h7.588a1.343 1.343 0 100-2.686zm-7.588 1h7.588a.342.342 0 110 .686h-7.588a.343.343 0 110-.686z"
}));

function SvgIconPorteOuverte(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 129
  }, props), _ref);
}

export default SvgIconPorteOuverte;